import { useState } from "react";
import { toast } from "sonner";
import { api, errText } from "@/lib/api";

export function ModeControls({ status, onChange }) {
  const [liveOpen, setLiveOpen] = useState(false);
  const [confirm, setConfirm] = useState("");
  if (!status) return null;

  const setMode = async (mode) => {
    if (mode === "live") { setLiveOpen(true); return; }
    try { await api.post("/trading/mode", { mode }); toast.success(`Mode: ${mode.toUpperCase()}`); onChange?.(); } catch (e) { toast.error(errText(e)); }
  };
  const confirmLive = async () => {
    try { await api.post("/trading/mode", { mode: "live", confirmation: confirm }); toast.warning("LIVE TRADING ENABLED"); setLiveOpen(false); setConfirm(""); onChange?.(); } catch (e) { toast.error(errText(e)); }
  };
  const setApproval = async (approval_mode) => {
    try { await api.post("/trading/approval-mode", { approval_mode }); toast.success(`Approval: ${approval_mode}`); onChange?.(); } catch (e) { toast.error(errText(e)); }
  };
  const toggleEngine = async () => {
    try {
      await api.post(status.engine_running ? "/trading/stop" : "/trading/start");
      toast.success(status.engine_running ? "Engine stopped" : "Engine started — first analysis cycle running");
      onChange?.();
    } catch (e) { toast.error(errText(e)); }
  };

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="mode-controls">
      <div className="seg" data-testid="trading-mode-selector">
        {["backtest", "paper", "live"].map((m) => <button key={m} onClick={() => setMode(m)} className={`${status.trading_mode === m ? `on ${m}` : ""}`} data-testid={`mode-${m}`}>{m.toUpperCase()}</button>)}
      </div>
      <div className="seg" data-testid="approval-mode-selector">
        {[["manual", "MANUAL"], ["semi_auto", "SEMI-AUTO"], ["auto", "AUTO"]].map(([k, l]) => <button key={k} onClick={() => setApproval(k)} className={status.approval_mode === k ? "on" : ""} data-testid={`approval-${k}`}>{l}</button>)}
      </div>
      <button onClick={toggleEngine} disabled={status.kill_switch} className={`${status.engine_running ? "btn-ghost text-[#f6465d]" : "btn-yellow"} rounded px-3 h-7 text-[11px]`} data-testid="engine-toggle-button">
        {status.engine_running ? "STOP ENGINE" : "START ENGINE"}
      </button>
      {liveOpen && (
        <div className="fixed inset-0 z-[70] flex items-center justify-center p-4" data-testid="live-confirm-modal">
          <div className="absolute inset-0 bg-black/70" onClick={() => setLiveOpen(false)} />
          <div className="relative w-full max-w-md bg-[#181a20] border border-[#f6465d]/60 rounded p-5 fade-in">
            <h2 className="font-display font-bold text-[#f6465d]">Enable LIVE trading?</h2>
            <p className="text-xs text-[#848e9c] mt-2">Real orders will be sent to your connected exchange. Requires an exchange credential with trading permission. Type <span className="mono text-white">LIVE TRADING ENABLED</span> to confirm.</p>
            <input className="input mono mt-3" value={confirm} onChange={(e) => setConfirm(e.target.value)} onKeyDown={(e) => e.key === "Escape" && setLiveOpen(false)} autoFocus placeholder="LIVE TRADING ENABLED" data-testid="live-confirm-input" />
            <div className="flex justify-end gap-2 mt-4">
              <button onClick={() => setLiveOpen(false)} className="btn-ghost rounded px-3 h-8 text-xs" data-testid="live-confirm-cancel">Cancel</button>
              <button onClick={confirmLive} disabled={confirm !== "LIVE TRADING ENABLED"} className="btn-red rounded px-3 h-8 text-xs disabled:opacity-40" data-testid="live-confirm-button">ENABLE LIVE</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
